const OPTIONS = {
    theme: 'limitless',
    progressBar: true,
    killer: false,
    timeout: 3000
}

export default {
    data() {
        return {
            doingAjax: false,
        };
    },
    methods: {
        callAction(type, payload = {}, onSuccess = null, onError = null) {
            if (this.doingAjax) {
                return;
            }
            this.doingAjax = true;

            let successHandler = this.createActionHandler(onSuccess ? onSuccess : null);
            let errorHandler = this.createActionHandler(
                onError ? onError : () => this.$noty.error('Something went wrong. Please contact support at support@easycontent.io', OPTIONS)
            );

            this.$store.dispatch(type, payload).then(successHandler, errorHandler);

        },
        createActionHandler(callback) {
            if (undefined === callback || !callback) {
                return () => this.doingAjax = false;
            }

            return response => {
                this.doingAjax = false;
                callback(response);
            }
        },
    }
}
